import React, { useState } from 'react';
import AdminMessageQueue from './AdminMessageQueue';
import PlaybookEditor from './PlaybookEditor';

/**
 * TomTab Component
 * Houses TOM's AI Message Review Queue and Plain-English Commercial Playbook Editor.
 */
const TomTab = () => {
  const [subTab, setSubTab] = useState('queue'); // 'queue' | 'playbook'

  return (
    <div className="p-6 md:p-8 bg-slate-50 min-h-[700px]">
      {/* TOM Sub-Header & Navigation */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 pb-4 border-b border-slate-200 gap-4">
        <div>
          <h2 className="text-2xl font-black text-slate-900 tracking-tight flex items-center gap-2">
            TOM <span className="text-blue-600">AI Communications</span>
          </h2>
          <p className="text-sm font-medium text-slate-500">
            Review inbound email drafts, automated milestone triggers, and fine-tune your Commercial Playbook.
          </p>
        </div>

        {/* Sub-Tab Navigation Toggle */}
        <div className="flex bg-slate-200 p-1 rounded-xl shadow-inner">
          <button
            onClick={() => setSubTab('queue')}
            className={`px-5 py-2 text-xs font-bold uppercase tracking-wider rounded-lg transition-all ${
              subTab === 'queue'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Message Queue
          </button>
          <button
            onClick={() => setSubTab('playbook')}
            className={`px-5 py-2 text-xs font-bold uppercase tracking-wider rounded-lg transition-all ${
              subTab === 'playbook'
                ? 'bg-white text-blue-600 shadow-sm'
                : 'text-slate-600 hover:text-slate-900'
            }`}
          >
            Playbook Editor
          </button>
        </div>
      </div>

      {/* Sub-Tab View Rendering */}
      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-6">
        {subTab === 'queue' ? <AdminMessageQueue /> : <PlaybookEditor />}
      </div>
    </div>
  );
};

export default TomTab;